module.exports = __webpack_public_path__ + "static/media/nyan_cat_long.5c8cf101.png";